import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { SsoMappingRulesBannerState } from '@layout/sso-mapping-rules-banner/store/states/sso-mapping-rules-banner.state';
import { LoadBannerVisibility, AcknowledgeBanner } from '@layout/sso-mapping-rules-banner/store/actions/sso-mapping-rules-banner.actions';

@Injectable({
  providedIn: 'root',
})
export class SsoMappingRulesBannerFacade {
  private readonly store = inject(Store);

  readonly showBanner = this.store.selectSignal(SsoMappingRulesBannerState.showBanner);
  readonly loading = this.store.selectSignal(SsoMappingRulesBannerState.loading);

  loadBannerVisibility(): void {
    this.store.dispatch(new LoadBannerVisibility());
  }

  acknowledgeBanner(): void {
    this.store.dispatch(new AcknowledgeBanner());
  }
}
